module.exports = __webpack_public_path__ + "img/icon_money.4894ec46.png";